// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1t_CM","approved":"Status_approved__2CNM4","rejected":"Status_rejected__228-_","expired":"Status_expired__2cIwd","label":"Status_label__TXWIi"};